import React from "react";

export default function Tips() {
  return (
    <>
      <div className="fs-5 px-5 pt-3">
        <p>
          As a conscious traveler, your choices can make a significant
          difference. By adopting sustainable travel practices, you contribute
          to the well-being of our planet and the communities you visit.
          <br />
          Here are some essential tips to help you embark on your journey with a
          responsible and ethical mindset.
        </p>
        <ol>
          <li>
            <span className="fw-bold fs-5">
              ☘️Choose Eco-Friendly Accommodations:
            </span>
            <p>
              Opt for accommodations that prioritize sustainability. Look for
              hotels, lodges, and guesthouses that implement energy-saving
              practices, waste reduction, and eco-friendly amenities.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🐾Reduce Your Carbon Footprint:</span>
            <p>
              <span className="fw-semibold fs-6">Minimize Flights:</span>
              Choose non-stop flights and consider alternative modes of
              transportation like trains or buses for shorter distances.
            </p>
            <p>
              <span className="fw-semibold fs-6">Offset Emissions:</span>
              Support carbon offset projects to neutralize the environmental
              impact of your travel.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🌊Conserve Water and Energy:</span>
            <p>
              <span className="fw-semibold fs-6">Use Resources Wisely:</span>
              Turn off lights, air conditioning, and faucets when not in use to conserve energy and water.
            </p>
            <p>
              <span className="fw-semibold fs-6">Reuse Towels:</span>
              Participate in towel reuse programs to reduce water consumption.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🤝Support Local Communities:</span>
            <p>
              <span className="fw-semibold fs-6">Buy Local:</span>
              Shop from local markets and artisans to support the local economy.
            </p>
            <p>
              <span className="fw-semibold fs-6">Engage with Locals:</span>
              Immerse yourself in local culture through cultural experiences, homestays, and community-led tours.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🥦Respect Wildlife and Nature:</span>
            <p>
              <span className="fw-semibold fs-6">No Harmful Souvenirs:</span>
              Refrain from buying products made from endangered species or materials that harm the environment.
            </p>
            <p>
              <span className="fw-semibold fs-6">Obeserve Wildlife Ethically:</span>
              Choose responsible wildlife tours that prioritize animal welfare and conservation.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🛍️Reduce Plastic Usage:</span>
            <p>
              <span className="fw-semibold fs-6">Carry Reusables:</span>
              Bring a reusable water bottle, shopping bag, and utensils to minimize single-use plastic consumption.
            </p>
            <p>
              <span className="fw-semibold fs-6">Say No To Straws:</span>
              Politely decline plastic straws and opt for reusable or paper alternatives.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🗑️Minimize Waste:</span>
            <p>
              <span className="fw-semibold fs-6">Pack Light:</span>
              Travel with a minimalist mindset to reduce excess baggage and waste.
            </p>
            <p>
              <span className="fw-semibold fs-6">Dispose Responsibly:</span>
              Use recycling and compost bins where available and avoid littering.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">☮️Choose Sustainable Tours and Activities:</span>
            <p>
              <span className="fw-semibold fs-6">Research Operators:</span>
              Opt for responsible tour operators that prioritize sustainability, cultural preservation, and community involvement. You can also checkout <a href="/operators">Our Hand-Picked Sustainable Operators</a>
            </p>
            <p>
              <span className="fw-semibold fs-6">Opt for Low-Impact Activities:</span>
              Choose activities that have minimal impact on the environment and respect local cultures.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🙌Practice Cultural Sensitivity:</span>
            <p>
              <span className="fw-semibold fs-6">Respect Local Customers:</span>
              Learn about and respect the cultural norms and practices of the places you visit.
            </p>
            <p>
              <span className="fw-semibold fs-6">Ask For Permission:</span>
              Always ask before taking photos of people, especially in sensitive or sacred areas.
            </p>
          </li>
          <li>
            <span className="fw-bold fs-5">🔍Leave No Trace:</span>
            <p>
              <span className="fw-semibold fs-6">Pack Out What You Pack In:</span>
              Dispose of waste properly and avoid leaving any trace of your visit behind.
            </p>
            <p>
              <span className="fw-semibold fs-6">Stay On Designated Paths:</span>
              Stick to marked trails to minimize damage to fragile ecosystems.
            </p>
          </li>
        </ol>
        <p>
          <span className="fw-bold fs-5">Your Journey, Your Impact</span> <br/>
          Every choice you make while traveling has an impact. By following these sustainable travel tips, you contribute to the preservation of natural environments, cultural diversity, and the overall well-being of the places you explore. Together, we can ensure that our wanderlust leaves a positive legacy for generations to come.
        </p>
      </div>
    </>
  );
}
